import json from './sprite.js';

export default {
    handle: 'SP_SPS5-Freetime',
    label: 'es_SPS5-Freetime_234684050',
    json,
};
